"use strict"

import React from "react"
import { FormattedMessage } from "react-intl"
import PropTypes from "prop-types"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import { sentencify } from "../../../shared_components/utils"
import PageLoadingPanel from "../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../shared_components/widgets/PageErrorPanel"
import { LanzaTable, UniversalFilter } from "../../../shared_components/widgets/LanzaTable"
import { LocaleFormattedDate } from "../../internationalization/LocaleFormatted"
import { withInventoryConfig } from "../../../config/InventoryConfigProvider"
import ProcurementItemButtons from "./ProcurementItemButtons"

const ProcurementTable = ({
  onItemReceived,
  inventoryTypes = [],
  procurementItems = [],
  statusProcurementItems,
  getProcurementItems,
}) => {
  return (
    <div>
      {statusProcurementItems === API_STATUS.LOADING && <PageLoadingPanel />}

      {statusProcurementItems === API_STATUS.ERROR && <PageErrorPanel attemptReload={getProcurementItems} />}

      {statusProcurementItems === API_STATUS.SUCCESS &&
        (procurementItems.length ? (
          <>
            <LanzaTable
              className={"table table-bordered tbl_lanzatable table-hover"}
              columns={[
                {
                  Header: <FormattedMessage id={"general.created.on"} />,
                  accessor: "created_on",
                  style: {
                    minWidth: "50px",
                  },
                  Cell: ({ value }) => {
                    return <LocaleFormattedDate date={value} shouldParse={true} />
                  },
                  disableFilters: true,
                },
                {
                  Header: <FormattedMessage id={"general.name"} />,
                  accessor: "name",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id={"general.description"} />,
                  accessor: "description",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id={"general.type"} />,
                  accessor: "inventory_type.name",
                  Filter: ({ column, preFilteredRows }) => (
                    <UniversalFilter
                      column={column}
                      setFilter={column.setFilter}
                      preFilteredRows={preFilteredRows}
                      filterType="select"
                      isClearable={false}
                      customOptions={inventoryTypes.map((t) => ({ value: t.name, text: t.name }))}
                    />
                  ),
                  style: {
                    minWidth: "100px",
                  },
                },
                {
                  Header: <FormattedMessage id={"stock.lot"} />,
                  accessor: "lot_no",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id={"stock.uom"} />,
                  accessor: "uom",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id={"stock.quantity"} />,
                  accessor: "quantity",
                  style: {
                    minWidth: "50px",
                  },
                },
                {
                  Header: <FormattedMessage id={"stock.retest_date"} />,
                  accessor: "retest_date",
                  style: {
                    minWidth: "50px",
                  },
                  Cell: ({ value }) => {
                    return <LocaleFormattedDate date={value} shouldParse={true} showTime={false} />
                  },
                  disableFilters: true,
                },
                {
                  Header: <FormattedMessage id={"inventory.expected_receive_date"} />,
                  accessor: "expected_receive_date",
                  style: {
                    minWidth: "50px",
                  },
                  Cell: ({ value }) => {
                    return <LocaleFormattedDate date={value} shouldParse={true} showTime={false} />
                  },
                  disableFilters: true,
                },
                {
                  Header: <FormattedMessage id={"general.status"} />,
                  accessor: "status",
                  style: {
                    minWidth: "50px",
                  },
                  Cell: ({ value }) => {
                    return sentencify(value)
                  },
                  Filter: ({ column, preFilteredRows }) => (
                    <UniversalFilter
                      column={column}
                      setFilter={column.setFilter}
                      preFilteredRows={preFilteredRows}
                      filterType="select"
                      isClearable={false}
                    />
                  ),
                },
                {
                  Header: "",
                  id: "actions",
                  style: {
                    minWidth: "50px",
                  },
                  accessor: (row) => {
                    if (row.status === "received") {
                      return <></>
                    } else {
                      return <ProcurementItemButtons row={row} onItemReceived={onItemReceived} />
                    }
                  },
                  disableSortBy: true,
                  disableFilters: true,
                },
              ]}
              data={procurementItems}
              allowSorting={true}
              allowFilters={true}
              initialTableOptions={{
                sortBy: [{ id: "created_on", desc: true }],
                pageSize: 10,
              }}
            />
          </>
        ) : (
          <div className={"center_middle"} style={{ height: "200px" }}>
            <div align={"center"}>
              <i className={"fa fa-info-circle"} style={{ fontSize: "45px" }} />
              <h4>
                <FormattedMessage id={"inventory.no-procurement-item-found"} />
              </h4>
            </div>
          </div>
        ))}
    </div>
  )
}

ProcurementTable.propTypes = {
  onItemReceived: PropTypes.func,
  getProcurementItems: PropTypes.func,
}

export default withInventoryConfig(ProcurementTable)
